import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { helpArticles } from '~/utils/helpArticles';
export function useRequestPM() {
    const { t: requestPaymentMethodTexts } = useLocaleKeys('hooks.requestPaymentMethod');
    const { t: commonButtons } = useLocaleKeys('common.buttons');
    const overlayContext = useOverlayContext();
    const { api, logBI } = useStoreActions();
    return async function requestPaymentMethod(agreementId) {
        const confirmed = await overlayContext.showModal({
            biName: 'request_payment_method_confirm',
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConfirmationModal, {
                    bi: {
                        primaryButton: {
                            name: 'use_request_payment_method_confirm'
                        },
                        secondaryButton: {
                            name: 'use_request_payment_method_cancel'
                        }
                    },
                    title: requestPaymentMethodTexts.title(),
                    testId: "request-pm-modal",
                    textAlignCenter: false,
                    content: /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                children: requestPaymentMethodTexts.onceYouSendRequest()
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(Typography, {
                                children: requestPaymentMethodTexts.considerSendingMessage()
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(ExternalLinkButton, {
                                openInNewTab: true,
                                underline: "none",
                                href: helpArticles.requestPaymentMethod(),
                                bi: {
                                    name: 'request_payment_method_learn_more'
                                },
                                children: requestPaymentMethodTexts.learnMore()
                            })
                        ]
                    }),
                    primaryButtonLabel: requestPaymentMethodTexts.sendRequest(),
                    primaryButtonTestId: "confirmation-modal-primary-btn",
                    secondaryButtonLabel: commonButtons.cancel(),
                    onPrimaryButtonClick: ()=>dismissModal(true),
                    onSecondaryButtonClick: ()=>dismissModal(false)
                });
            }
        });
        if (confirmed) {
            logBI(11253);
            overlayContext.startLoader('request-pm-loader');
            try {
                await api.relationship.requestPaymentMethod(agreementId);
                overlayContext.showSuccessToast(requestPaymentMethodTexts.paymentMethodRequestSent(), 'request-pm-success-toast');
            } catch (err) {
                overlayContext.showErrorToast(requestPaymentMethodTexts.failedToRequestPaymentMethod(), 'request-pm-error-toast');
            } finally{
                overlayContext.stopLoader('request-pm-loader');
            }
        }
    };
}
